export const PROJECT_LIFECYCLE_PHASES = [
  "tender_and_planning",
  "design",
  "production",
  "final_inspection",
] as const;

export const RECOVERABILITY_STATUSES = [
  "paid",
  "ongoing",
  "unpaid",
  "unclear",
  "disputed",
] as const;

export const DATA_COMPLETENESS_STATUSES = ["complete", "partial", "missing"] as const;

export const DRIVER_TYPES = ["cost", "time"] as const;

export const KB_BLOCK_IDS = [
  "header",
  "project_brief",
  "knowledge_quality",
  "outcome_money",
  "outcome_time",
  "drivers",
  "early_warnings",
  "playbook",
] as const;

/** Root cause / pattern category for a driver. */
export const DRIVER_TAGS = [
  "design_error",
  "specification_gap",
  "change_order",
  "late_notice",
  "coordination_failure",
  "rework",
  "quality_gap",
  "documentation_gap",
  "disputed",
  "high_impact",
  "preventable",
] as const;

/** Narrative insight tag on an outcome driver reference. */
export const OUTCOME_INSIGHT_TAGS = [
  "preventable",
  "requirement_shift",
  "dispute_risk",
  "rework",
  "notice_issue",
  "recovery_blocked",
] as const;
